import * as FLOWS from '#client/config/flows';

/**
 * Array of flow configurations for the application.
 */
const FLOW_CONFIG = [
  FLOWS.beneficialOwnershipInformation,
  FLOWS.cora,
  FLOWS.corp,
  FLOWS.corpAddons,
  FLOWS.llc,
  FLOWS.llcMb,
  FLOWS.llc25PctOffRa,
  FLOWS.llc50PctOffRa,
  FLOWS.llcAddons,
  FLOWS.llcGodaddy,
  FLOWS.llcPackagesPromo,
  FLOWS.llcNerdwallet,
  FLOWS.llcVerizon,
  FLOWS.llcVx,
  FLOWS.quote,
  FLOWS.smartLlc,
  FLOWS.sCorp,
  FLOWS.sCorpAddons,
  ...FLOWS.llcPaidStates
];

export const DEFAULT_FLOW_ID = FLOWS.llc.id;

export default FLOW_CONFIG;
